import { colors } from "@indeed/ifl-tokens";

import { Flex, Box, Text, Star } from "../../../../../../mads";
import { useI18n } from "../../../../../../shared/I18n";

export function CondensedRatingInfo(props: { rating: string }) {
  // Add decimal if needed
  const formattedRating = parseFloat(props.rating).toFixed(1);

  const i18n = useI18n();
  const formattedLabel = i18n.gettext("{0} out of 5 stars", [formattedRating]);

  return (
    <Flex sx={{ flexDirection: "row", alignItems: "center" }}>
      <Box sx={{ paddingLeft: 8, paddingRight: 8 }}>
        <Text sx={{ fontWeight: "800" }}>·</Text>
      </Box>

      <Box>
        <Text variant="contrast" level={3} ariaLabel={formattedLabel}>
          {formattedRating}
        </Text>
      </Box>

      <Box sx={{ paddingLeft: 6 }}>
        <Star size="sm" aria-hidden color={colors.neutral[1000]} />
      </Box>
    </Flex>
  );
}

export default CondensedRatingInfo;
